import React from 'react'
import {
  Section,
  ContainerLg,
  Lead,
  H2,
  H3,
  Paragraph,
  RowCentered
} from '../../GlobalStylesNew'
import { Row, Col } from 'reactstrap'
import { StaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image/withIEPolyfill'
import { prop } from 'ramda'
import styled from 'styled-components'
import theme from '../../theme'
import { ButtonLink } from '../../common/Links'
import gtmEvent from '../../../utils/gtm'
import Logos from '../Logos'

export const AdmSection = styled(Section)`
  background-color: ${theme.colors.white};
  padding: 50px 0 35px;
  text-align: left;
  @media screen and (min-width: 768px) {
    padding: 100px 0;
  }
  @media screen and (min-width: 1024px) {
    padding: 150px 0 120px;
  }
`
export const CustomHeading = styled(H2)`
  margin-bottom: 20px;
  text-align: left;
  @media (min-width: 768px) {
    margin-bottom: 0px;
  }
`

export const CustomLead = styled(Lead)`
  margin: 20px 0;
  color: ${theme.colors.navy};
  max-width: 700px;
  @media screen and (min-width: 768px) {
    margin: 20px 0 50px;
  }
  @media screen and (min-width: 1024px) {
    margin: 50px 0;
  }
`
export const Testimonials = styled.div`
  background: rgba(131, 111, 80, 0.24);
  padding: 30px;
  margin-top: 36px;
  @media screen and (min-width: 768px) {
    margin-top: 100px;
  }
  @media screen and (min-width: 1024px) {
    margin-top: 0;
  }
`
export const ImgWrapper = styled.div`
  float: left;
  margin-right: 10px;
`
export const LogoWrapper = styled(RowCentered)`
  margin-top: 35px;
  @media screen and (min-width: 1024px) {
    margin-top: 50px;
  }
`

const handleButtonClick = () => {
  gtmEvent({
    event: 'index-page-click',
    indexPageCategory: 'get-adm-cta',
    indexPageLabel: 'get-started',
    indexPageAction: 'click-get-adm-cta'
  })
}

const Adm = props => {
  return (
    <StaticQuery
      query={graphql`
        query {
          Author: file(relativePath: { eq: "Home/author1.png" }) {
            ...optimizedImage
            childImageSharp {
              fixed(width: 50, height: 50) {
                ...GatsbyImageSharpFixed
              }
            }
          }
          logo_adm: file(relativePath: { eq: "Home/logos/logo_adm.png" }) {
            ...optimizedImage
            childImageSharp {
              fixed(width: 305, height: 90) {
                ...GatsbyImageSharpFixed
              }
            }
          }
        }
      `}
      render={data => (
        <AdmSection id='get-started'>
          <ContainerLg className='container-xl'>
            <Row>
              <Col lg='8' xs='12'>
                <CustomHeading color={theme.colors.navy}>
                  Get ADM certified.
                  <span className='d-none d-lg-block'>It’s the first step</span>
                </CustomHeading>
                <CustomLead>
                  The American Development Model is essential for growing the
                  sport and vital to you and your employer’s success.{' '}
                </CustomLead>
                <ButtonLink
                  url='https://pgacoach.lightspeedvt.com'
                  bgColor={theme.colors.gold}
                  borderColor={theme.colors.gold}
                  color={theme.colors.white}
                  bgHoverColor={theme.colors.darkGold}
                  borderHoverColor={theme.colors.darkGold}
                  btnStyle='primary'
                  padding='14px 30px'
                  aria-label='Get Started Today'
                  onClick={handleButtonClick}
                >
                  Get Started Today
                </ButtonLink>
              </Col>
              <Col lg='4' className='d-none d-lg-block'>
                <Testimonials>
                  <Paragraph>
                    “I received my ADM-Golf Certification just a few days ago. I
                    am really excited about integrating Stages 2-3-4 into my
                    OFGC PGA JL Program. This new approach is a game changer and
                    I am excited to be on the ground floor.
                  </Paragraph>
                  <ImgWrapper>
                    {prop('Author', data) ? (
                      <Img fixed={data.Author.childImageSharp.fixed} />
                    ) : null}
                  </ImgWrapper>
                  <Paragraph>
                    {' '}
                    <b>
                      {' '}
                      Jex H. Wilson
                      <br />
                      PGA Master Professional
                    </b>
                  </Paragraph>
                </Testimonials>
              </Col>
            </Row>
            <Row>
              <Logos />
            </Row>
            <Row>
              <Col lg='4' xs='12' className='mb-3 mb-lg-0'>
                <H3 className='text-left'>What is the ADM?</H3>
                <Lead color={theme.colors.navy}>
                  Golf’s new pathway is built on the principles of the American
                  Development Model (ADM), a proven, long-term athlete
                  development model that has been successfully applied to USA
                  Hockey, USOC, USA Basketball and USA Lacrosse.
                </Lead>
              </Col>
              <Col lg='4' xs='12' className='mb-3 mb-lg-0'>
                <H3 className='text-left'>How does ADM work?</H3>
                <Lead color={theme.colors.navy}>
                  Creating positive experiences early, for all athletes, will
                  keep more players engaged and retained in our sport.
                  Introducing the right aspects of play in a structure that is
                  fun, engaging, and progressively challenging, allows golfers
                  of all ages to experience the challenges and joys of our
                  sport.
                </Lead>
              </Col>
              <Col lg='4' xs='12'>
                <H3 className='text-left'>Why does ADM work?</H3>
                <Lead color={theme.colors.navy}>
                  American Development Model was designed by sports scientists
                  to help support a lifetime affinity to sports, and to develop
                  athletes to their greatest potential. These principles align
                  physical and psychological development to stages, delivering
                  appropriate skills and exercise at the appropriate time.
                </Lead>
              </Col>
              <Col lg='12' className='d-lg-none'>
                <Testimonials>
                  <Paragraph>
                    “I received my ADM-Golf Certification just a few days ago. I
                    am really excited about integrating Stages 2-3-4 into my
                    OFGC PGA JL Program. This new approach is a game changer and
                    I am excited to be on the ground floor.
                  </Paragraph>
                  <ImgWrapper>
                    {prop('Author', data) ? (
                      <Img fixed={data.Author.childImageSharp.fixed} />
                    ) : null}
                  </ImgWrapper>
                  <Paragraph>
                    {' '}
                    <b>
                      {' '}
                      Jex H. Wilson
                      <br />
                      PGA Master Professional
                    </b>
                  </Paragraph>
                </Testimonials>
              </Col>
              <Col md={{ size: 12, offset: 0 }} xs={{ size: 6, offset: 3 }}>
                <LogoWrapper>
                  {prop('logo_adm', data) ? (
                    <Img
                      fixed={data.logo_adm.childImageSharp.fixed}
                      objectFit='contain'
                      objectPosition='50% 50%'
                      className='mt-lg-5'
                    />
                  ) : null}
                </LogoWrapper>
              </Col>
            </Row>
          </ContainerLg>
        </AdmSection>
      )}
    />
  )
}

export default Adm
